import { Grid } from '@mui/material';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import { Form, Formik } from 'formik';
import React from 'react';
import { companySchema } from 'FeatureModules/Setting/schemas/company.schema';
import CompanyFields from './CompanyFields';
import { ICompany } from 'FeatureModules/Auth/types/company.types';

interface IProps {
  company: ICompany;
  onSubmit: (company: Partial<ICompany>) => void;
}

const CompanyEditForm: React.FC<IProps> = ({ company, onSubmit }) => {
  // Destructure to make sure not all fields are submitted through the form like the id etc.
  const {
    description,
    name,
    onlineShop,
    website,
    logo,
    social,
    vatNumber,
    eoriNumber,
    countriesOfBusiness,
  } = company;

  const initialValues = {
    description,
    name,
    onlineShop,
    website,
    logo,
    social,
    vatNumber,
    eoriNumber,
    countriesOfBusiness,
  };

  return (
    <Formik
      validateOnChange
      initialValues={initialValues}
      validateOnBlur={false}
      validationSchema={companySchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <Grid container>
            <CompanyFields />
            <Grid container item justifyContent="flex-end" alignItems="center">
              <ThemeButton size="large" color="PRIMARY" loading={isSubmitting} type="submit">
                Save
              </ThemeButton>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default CompanyEditForm;
